/**
 * @generated SignedSource<<df44afea5b9cf8d8bf7d7a38e7f978bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateDepartureLocationInput = {
  codes?: ReadonlyArray<string> | null;
  name?: string | null;
};
export type DepartureLocationEditFormMutation$variables = {
  id: string;
  input: UpdateDepartureLocationInput;
};
export type DepartureLocationEditFormMutation$data = {
  readonly updateDepartureLocation: {
    readonly " $fragmentSpreads": FragmentRefs<"DepartureLocationEditForm_departureLocation" | "EntitySidebar_entity">;
  };
};
export type DepartureLocationEditFormMutation = {
  response: DepartureLocationEditFormMutation$data;
  variables: DepartureLocationEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DepartureLocationEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DepartureLocation",
        "kind": "LinkedField",
        "name": "updateDepartureLocation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DepartureLocationEditForm_departureLocation"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DepartureLocationEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DepartureLocation",
        "kind": "LinkedField",
        "name": "updateDepartureLocation",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "codes",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21c9186f74c3b9e64a3f45eab3ee8ec7",
    "id": null,
    "metadata": {},
    "name": "DepartureLocationEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation DepartureLocationEditFormMutation(\n  $id: ID!\n  $input: UpdateDepartureLocationInput!\n) {\n  updateDepartureLocation(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...DepartureLocationEditForm_departureLocation\n    id\n  }\n}\n\nfragment DepartureLocationEditForm_departureLocation on DepartureLocation {\n  id\n  name\n  codes\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "246d3540078c70b5322071b99bc0f432";

export default node;
